import {cva} from 'class-variance-authority'

/**
 * Track (the 48×24 pill). Color + checked + disabled drive the fill and the
 * inset shadow. Off-state is a light tint of the on color (per Figma); disabled
 * collapses both colors to the neutral `action.disabled-background`.
 */
export const SwitchTrackVariants = cva(
  'absolute left-1/2 top-1/2 h-6 w-12 -translate-x-1/2 -translate-y-1/2 rounded-full transition-colors duration-200 motion-reduce:transition-none',
  {
    variants: {
      color: {
        primary: '',
        favorite: '',
      },
      checked: {true: '', false: ''},
      disabled: {true: '', false: ''},
    },
    compoundVariants: [
      // primary
      {
        color: 'primary',
        checked: true,
        disabled: false,
        class: 'bg-primary shadow-[inset_0px_4px_4px_0px_rgba(0,136,149,0.25)]',
      },
      {
        color: 'primary',
        checked: false,
        disabled: false,
        class: 'bg-[#A5DCE1] shadow-[inset_0px_2px_2px_0px_rgba(0,136,149,0.1)]',
      },
      // favorite
      {
        color: 'favorite',
        checked: true,
        disabled: false,
        class: 'bg-favorite shadow-[inset_0px_4px_4px_0px_rgba(88,41,149,0.25)]',
      },
      {
        color: 'favorite',
        checked: false,
        disabled: false,
        class: 'bg-[#D8CFE4] shadow-[inset_0px_2px_2px_0px_rgba(111,51,188,0.1)]',
      },
      // disabled (either color)
      {
        disabled: true,
        class: 'bg-action-disabled-background shadow-[inset_0px_2px_2px_0px_rgba(13,31,33,0.1)]',
      },
    ],
    defaultVariants: {color: 'primary', checked: false, disabled: false},
  },
)

/**
 * The soft state halo behind the thumb (~37px). Transparent at rest; tinted on
 * hover/focus-visible/pressed via the parent `group`. Primary uses the aqua
 * `action.*` overlays; favorite uses its own purple overlay.
 */
export const SwitchHaloVariants = cva(
  'pointer-events-none absolute left-1/2 top-1/2 size-[37px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-transparent transition-colors duration-150 motion-reduce:transition-none',
  {
    variants: {
      color: {
        primary:
          'group-hover:bg-action-hover group-focus-visible:bg-action-focus group-active:bg-action-focus',
        favorite:
          'group-hover:bg-[rgba(157,112,216,0.16)] group-focus-visible:bg-[rgba(157,112,216,0.16)] group-active:bg-[rgba(157,112,216,0.16)]',
      },
    },
    defaultVariants: {color: 'primary'},
  },
)
